import { Language } from '../../enums/language/language';

export class AudioItem {
  public description?: string;
  public language?: Language;
  public videoUrl?: string;
  public currentTime?: number;
}
